import { useEffect } from 'react';
import { useTextForm } from '../useTextForm';

export const useClientTextForm = (textForm, isLoading) => {
  const base = useTextForm(textForm, isLoading);

  useEffect(() => {
    if (!textForm) return;

    const originalText =
      textForm.actualHtmlContent?.replace(
        new RegExp('style="color: red;"', 'g'),
        'style="color: black;"'
      ) || '';

    base.setActualHtmlContent(originalText);
  }, [textForm, isLoading]);

  return base;
};
